import {date} from './format';

export default date;



// 当前时区
const CUR_TIME_ZONE = - (new Date()).getTimezoneOffset() / 60;


// 中国时区差
let zone8TimeZoneDiff = 8 - CUR_TIME_ZONE;


/**
 * 用+8时区解析时间字符串
 */
export function formatDateUseZone8(timestamp, str) {
  return date(timestamp, str, zone8TimeZoneDiff);
}



/**
 * 设置 与源时区日期时间的 在目标时区下的 小时值
 */
export function setHoursByZone(timestamp, hours, targetZone = CUR_TIME_ZONE, sourceZone = CUR_TIME_ZONE) {
  let sDate = mockZoneDate(timestamp, sourceZone); // 源时区 同小时值
  let zoneDiff = targetZone - CUR_TIME_ZONE;

  typeof hours === 'undefined' && (hours = sDate.getHours());
  hours -= zoneDiff;

  sDate.setHours(hours); // 目标时区 同小时值
  sDate.setMinutes(0);
  sDate.setSeconds(0);

  timestamp = sDate.getTime();
  return timestamp;
}



/**
 * 模拟目标时区，获取Date对象
 */
function mockZoneDate(timestamp, targetZone = CUR_TIME_ZONE) {
  let date = new Date(timestamp);

  let hours = date.getHours();
  hours += targetZone - CUR_TIME_ZONE;

  date.setHours(hours);
  return date;
}


// WEBPACK FOOTER //
// ./src/utils/formatDate.js